import { Box, Button, CircularProgress, FormControl, IconButton, InputAdornment, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useEffect, useState } from "react";

const SUCURSALES = ["La Paz", "Santa Cruz", "Cochabamba", "Oruro", "Potosi", "Sucre", "Tarija", "Beni", "Pando"];

export default function SearchBar({
  onSearch,
  searching,
  servicios = [],
  loadingServicios = false,
  sucursalDefault = "",
  excludeServicioNombre = "",
  precargar = null, // { nombreCliente, estado, codServicio, sucursal, n }: rellena el formulario (n cambia en cada uso)
}) {
  const [estado, setEstado] = useState("Activo");
  const [nombreCliente, setNombreCliente] = useState("");
  const [codServicio, setCodServicio] = useState("");
  const [sucursal, setSucursal] = useState(sucursalDefault);

  // Acepta uno o varios nombres separados por coma (ej: "AVL,Scada")
  const excludeList = String(excludeServicioNombre || "")
    .split(",")
    .map((s) => s.trim().toUpperCase())
    .filter(Boolean);
  const serviciosVisibles = excludeList.length
    ? servicios.filter((s) => !excludeList.includes(String(s.nombre || "").trim().toUpperCase()))
    : servicios;

  useEffect(() => {
    if (!precargar) return;
    setNombreCliente(precargar.nombreCliente || "");
    setEstado(precargar.estado || "Activo");
    setCodServicio(precargar.codServicio || "");
    setSucursal(precargar.sucursal || "");
  }, [precargar]);

  useEffect(() => {
    setSucursal(sucursalDefault || "");
  }, [sucursalDefault]);

  useEffect(() => {
    if (excludeList.length || !servicios.length) return;
    const avl = servicios.find(
      (servicio) => String(servicio.nombre || "").trim().toUpperCase() === "AVL"
    );
    if (avl) {
      setCodServicio((actual) => actual || avl.id_servicio);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [servicios, excludeServicioNombre]);

  const handleSubmit = (e) => {
    e.preventDefault();
    onSearch({ nombreCliente, estado, codServicio, sucursal });
  };

  return (
    <Box
      component="form"
      onSubmit={handleSubmit}
      sx={{
        display: "flex",
        gap: 1,
        flexWrap: "wrap",
        alignItems: "center",
        mb: 1.5,
        "& .MuiInputBase-root": { height: 34, fontSize: "0.82rem" },
        "& .MuiInputLabel-root": { fontSize: "0.82rem" },
        "& .MuiButton-root": { minHeight: 34, px: 1.5, fontSize: "0.78rem" },
        "& .MuiOutlinedInput-notchedOutline": { borderRadius: "8px" },
      }}
    >
      <TextField
        size="small"
        label="Nombre del cliente"
        value={nombreCliente}
        onChange={(e) => setNombreCliente(e.target.value)}
        autoComplete="off"
        sx={{ width: 210 }}
        slotProps={{
          input: {
            endAdornment: nombreCliente ? (
              <InputAdornment position="end">
                <IconButton size="small" edge="end" aria-label="Borrar nombre" onClick={() => setNombreCliente("")} sx={{ p: 0.25 }}>
                  <CloseIcon sx={{ fontSize: 16 }} />
                </IconButton>
              </InputAdornment>
            ) : null,
          },
        }}
      />
      <FormControl size="small" sx={{ minWidth: 125 }}>
        <InputLabel id="estado-label">Estado</InputLabel>
        <Select labelId="estado-label" label="Estado" size="small" value={estado} onChange={(e) => setEstado(e.target.value)}>
          <MenuItem value="Todos">Todos</MenuItem>
          <MenuItem value="Activo">Activo</MenuItem>
          <MenuItem value="Inactivo">Inactivo</MenuItem>
        </Select>
      </FormControl>
      <FormControl size="small" sx={{ minWidth: 155 }}>
        <InputLabel id="servicio-label">Servicio</InputLabel>
        <Select
          labelId="servicio-label"
          label="Servicio"
          size="small"
          value={codServicio}
          onChange={(e) => setCodServicio(e.target.value)}
          disabled={loadingServicios}
        >
          <MenuItem value="">Todos</MenuItem>
          {serviciosVisibles.map((servicio) => (
            <MenuItem key={servicio.id_servicio} value={servicio.id_servicio}>
              {servicio.nombre}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <FormControl size="small" sx={{ minWidth: 145 }}>
        <InputLabel id="sucursal-busqueda-label">Sucursal</InputLabel>
        <Select
          labelId="sucursal-busqueda-label"
          label="Sucursal"
          size="small"
          value={sucursal}
          onChange={(e) => setSucursal(e.target.value)}
        >
          <MenuItem value="">Todos</MenuItem>
          {SUCURSALES.map((s) => (
            <MenuItem key={s} value={s}>
              {s}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <Button type="submit" variant="contained" disabled={searching}>
        {searching ? <><CircularProgress size={18} sx={{ mr: 1 }} /> Buscando…</> : "Buscar"}
      </Button>
    </Box>
  );
}
